import Badge from 'components/Badge'
import { BadgeVariant } from 'constants/roles'
import { buildTranslate } from 'locales'

const t = buildTranslate('dashboard_access.roles_tab')

type Props = {
  variant: BadgeVariant | null
  className?: string
}

export const RoleBadge = ({ variant, className = '' }: Props) => {
  if (!variant) return null

  const badgeClassName =
    variant === 'standard'
      ? `spearmint-50 spearmint-10-bkg ${className}`
      : `grey-70 grey-20-bkg ${className}`

  return <Badge className={badgeClassName} value={t(`badge.${variant}`)} />
}
